export default {
  searchForm: {
    choseLabel: '筛选',
    chosePlaceholder: '请选择商城',
    timeLabel: '时间范围',
    classLabel: 'Top品类',
    topLabel: 'Top品数范围',
    submitText: '提交',
    exportText: '导出',
    last7: '最后7天',
    last30: '最后30天',
    top30: '前30名',
    top50: '前50名',
    top100: '前100名',
  },
  topTableCard: {
    title: '商城热门指数排行榜',
    columns: {
      country: '国家',
      shopName: '商城名称',
      opt: '指数（折扣价）',
      ret: '指数（原价）',
      lineProgress: '条形图',
      value: '数值',
      skuImg: 'sku占位图',
      commonSku: '共有sku',
    },
  },
  topModal: {
    title: '详情',
    addTo: '添加收藏夹',
    image: '图片',
    name: '商城名称',
    brand: '品牌',
  },
};
